import { MoreHorizontal } from "lucide-react"

const vaults = [
  {
    name: "Bitcoin",
    symbol: "BTC",
    price: "$13,643.21",
    daily: "+$213.8",
    balance: "$13,954.04",
    apy: "8.56%",
    state: "Fixed",
    startDate: "05.10.2023",
    liquidity: "high",
  },
  {
    name: "USDT",
    symbol: "USDT",
    price: "$1.00",
    daily: "+$45.1",
    balance: "$3,954.04",
    apy: "5.44%",
    state: "Fixed",
    startDate: "12.03.2023",
    liquidity: "medium",
  },
  {
    name: "Ethereum",
    symbol: "ETH",
    price: "$2,123.87",
    daily: "+$13.5",
    balance: "$3,954.04",
    apy: "4.12%",
    state: "Flexible",
    startDate: "21.01.2023",
    liquidity: "low",
  },
]

export function VaultTable() {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b">
            <th className="py-3 px-4 text-left font-medium">Vault</th>
            <th className="py-3 px-4 text-left font-medium">Daily</th>
            <th className="py-3 px-4 text-left font-medium">Balance ↓</th>
            <th className="py-3 px-4 text-left font-medium">APY ↓</th>
            <th className="py-3 px-4 text-left font-medium">State</th>
            <th className="py-3 px-4 text-left font-medium">Start date</th>
            <th className="py-3 px-4 text-left font-medium">Liquidity</th>
            <th className="py-3 px-4 text-left font-medium"></th>
          </tr>
        </thead>
        <tbody>
          {vaults.map((vault) => (
            <tr key={vault.symbol} className="border-b hover:bg-gray-50">
              <td className="py-3 px-4 font-medium">
                <div className="flex items-center gap-2">
                  <div className="h-6 w-6 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
                    <img src={`/placeholder.svg?height=24&width=24`} alt={vault.name} />
                  </div>
                  <div>
                    <div className="font-medium">{vault.name}</div>
                    <div className="text-xs text-gray-500">{vault.price}</div>
                  </div>
                </div>
              </td>
              <td className="py-3 px-4 text-green-500">{vault.daily}</td>
              <td className="py-3 px-4">{vault.balance}</td>
              <td className="py-3 px-4">{vault.apy}</td>
              <td className="py-3 px-4">
                <span
                  className={`inline-flex items-center rounded-full px-2 py-1 text-xs ${
                    vault.state === "Fixed" ? "bg-yellow-500/10 text-yellow-500" : "bg-green-500/10 text-green-500"
                  }`}
                >
                  {vault.state}
                </span>
              </td>
              <td className="py-3 px-4">{vault.startDate}</td>
              <td className="py-3 px-4">
                <div className="flex gap-1">
                  {Array.from({ length: 3 }).map((_, i) => (
                    <div
                      key={i}
                      className={`h-1.5 w-3 rounded-full ${
                        i < (vault.liquidity === "high" ? 3 : vault.liquidity === "medium" ? 2 : 1)
                          ? "bg-[#D4AF37]"
                          : "bg-gray-200"
                      }`}
                    />
                  ))}
                </div>
              </td>
              <td className="py-3 px-4">
                <MoreHorizontal className="h-4 w-4 text-gray-500" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

